export default __webpack_public_path__ + "reallusion-cartoon.c9288bc7.png";